/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upgrade_Alert_MessageInputs */

const en_mobile_upgrade_alert_message = /** @type {(inputs: Mobile_Upgrade_Alert_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A newer version of Listening is available.`)
};

const es_mobile_upgrade_alert_message = /** @type {(inputs: Mobile_Upgrade_Alert_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay una versión nueva de Listening disponible.`)
};

/**
* | output |
* | --- |
* | "A newer version of Listening is available." |
*
* @param {Mobile_Upgrade_Alert_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upgrade_alert_message = /** @type {((inputs?: Mobile_Upgrade_Alert_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upgrade_Alert_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upgrade_alert_message(inputs)
	return en_mobile_upgrade_alert_message(inputs)
});